import { useEffect, useRef, useState } from "react";
import ProjectRadioSetting from "./ProjectRadioSetting";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { statusProjectSettingsApi } from "../../../Data/axios";
import StatusAlert from "../../../StatusAlertList/StatusAlert";

const ProjectSettingsTab = () => {
  const [hide, setHide] = useState(false);
  const [leadSource, setLeadSource] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [selectedValue, setSelectedValue] = useState("3"); // Default value
  const [remainderDays, setRemainderDays] = useState("");
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  const [isChecked, setIsChecked] = useState(true); // Initialize the state

  const handleClick = (event) => {
    setHide((prev) => !prev);
    setIsChecked(event.target.checked); // Update the state with the checked value
  };

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const StyledCheckBoxOutlineBlankIcon = styled(CheckBoxOutlineBlankIcon)({
    fontSize: "1.5rem", // Set the size you want
  });

  const StyledCheckBoxIcon = styled(CheckBoxIcon)({
    fontSize: "1.5rem", // Set the size you want
  });
  
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setRemainderDays(leadSource.remenber_after_days);
    setIsChecked(leadSource.project_reminder === 1 ? true : false);
    setHide(leadSource.project_reminder === 1 ? true : false);
    setSelectedValue(leadSource.remender_to);
  }, [leadSource]);

  async function getData() {
    const response = await statusProjectSettingsApi.getAll();
    setLeadSource(response);
  }

  const handleSaveBtn = async () => {
    const item = {
      project_reminder: isChecked === true ? "1" : "0",
      remender_to: selectedValue,
      remenber_after_days: remainderDays,
    };

    try {
      const formData = new FormData();
      for (const key in item) {
        if (item[key] !== undefined && item[key] !== null) {
          formData.append(key, item[key]);
        }
      }
      await statusProjectSettingsApi.update(formData);
      showAlert(" Updated Successfully!", "success");
      getData();
    } catch (error) {
      console.error("Fetch error:", error);
      showAlert("Failed to add ", "error");
    }
  };

  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      <Box sx={{ color: "black", maxWidth: "800px", padding: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Checkbox
              {...label}
              onClick={handleClick}
              checked={isChecked}
              icon={<StyledCheckBoxOutlineBlankIcon />}
              checkedIcon={<StyledCheckBoxIcon />}
              sx={{
                color: "primary.main",
                "&.Mui-checked": {
                  color: "#1d82f5",
                },
              }}
              aria-label="Send Reminder" // Added aria-label
            />
            <span style={{ fontSize: "1rem" }}>
              <span>Send Reminder</span>
            </span>
          </Grid>
          <Grid item xs={12}>
            {hide && (
              <Box
                sx={{
                  flexFlow: 1,
                  bgcolor: "white",
                  padding: 2,
                  borderRadius: 1,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <ProjectRadioSetting
                      selectedValue={selectedValue}
                      setSelectedValue={setSelectedValue}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <p style={{ fontSize: "1rem" }}>Remind before *</p>

                    <input
                      type="text"
                      name="days"
                      id="day"
                      value={remainderDays}
                      onChange={(e) => setRemainderDays(e.target.value)}
                      style={{
                        width: "50%",
                        borderRadius: 0,
                        border: "1px solid gray",
                        padding: "8px",
                      }}
                      aria-label="days" // Added aria-label
                    />
                    <span
                      style={{
                        border: "1px solid gray",
                        padding: "10px",
                        paddingBottom: "11px",
                      }}
                    >
                      Days
                    </span>
                  </Grid>
                </Grid>
                <Button
                  sx={{
                    backgroundColor: "#1d82f5",
                    "&:hover": {
                      backgroundColor: "orange",
                    },
                    color: "white",
                    marginTop: 2,
                  }}
                  onClick={handleSaveBtn}
                >
                  Save
                </Button>
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ProjectSettingsTab;
